import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'offers-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const offersAnalytics = require('./containers/OffersAnalyticsContainer').default;
      const {loadOffersReducer} = require('./modules/OffersAnalytics');

      injectReducer(store, {key: 'offers', reducer: loadOffersReducer});

      /*  Return getComponent   */
      callback(null, offersAnalytics)

      /* Webpack named bundle   */
    }, 'OffersAnalyticsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OffersAnalytics/index.js